import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles, Grid } from '@material-ui/core';
import { formattingDigitCurrency } from 'utils';
import { useAtom } from 'jotai';
import { staticDataAtom } from 'Atoms/Common';
import { useTranslation } from 'react-i18next';
import { BlueCheckbox } from 'Components/UI';

const useStyles = makeStyles((theme) => ({
  quantity: {
    fontWeight: 700,
  },
  label: {
    margin: '0 .5rem',
    verticalAlign: 'top',
  },
  price: {
    float: 'right',
  },
  to_pay: {
    marginLeft: 'auto',
    display: 'block',
    width: 'fit-content',
    fontSize: '12px',
    paddingTop: '3px',
    opacity: 0.5,
    whiteSpace: 'nowrap'
  },
  checkbox: {
    color: theme.palette.primary.main,
    borderRadius: '5px',
  },
  sublines: {
    paddingLeft: '1.7rem',
  },
  sublineTxt: {
    fontSize: '14px',
  },
  oldPrice: {
    textDecoration: 'line-through',
    opacity: 0.7,
  },
  sublinePrice: {
    fontSize: '14px',
  },
}));

/**
 *
 * @param {action} object with params "name": readOnly || selected
 */
const DetailProductLine = ({
  action,
  idProduct,
  idCheckbox,
  label,
  price,
  quantity,
  productSelected,
  handleSetItemSelected,
  priceBeforeDiscount,
  idSection,
  sublines,
  offered,
  pricePaid
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [staticData] = useAtom(staticDataAtom);
  const { countryCode, labelCode } = staticData?.currency;

  const { name } = action || {};
  const [checked, setChecked] = useState(false);
  const amountFormatting = formattingDigitCurrency(
    price,
    countryCode,
    labelCode,
  );

  const handleChange = (e) => {
    const productIsAlreadyIn = productSelected.find(
      (item) => item.idCheckbox === idCheckbox,
    );
    const addProduct = productIsAlreadyIn ? false : true;
    const product = {
      idProduct,
      label,
      idCheckbox,
      price: price - pricePaid,
      priceBeforeDiscount,
      quantity,
      idSection,
      sublines
    };
    setChecked(addProduct);
    handleSetItemSelected(product, addProduct);
  };

  const totalSubline = (price) => {
    if (price > 0) {
      return formattingDigitCurrency(price, countryCode, labelCode);
    } else {
      return '';
    }
  };
  return (
    <>
      <div onClick={name === 'readOnly' ? null : handleChange}>
        {name === 'readOnly' && (
          <Typography display="inline" className={classes.quantity}>
            {quantity}x
          </Typography>
        )}
        {name === 'selected' && (
          <BlueCheckbox
            checked={checked}
            onChange={handleChange}
            className={classes.checkbox}
            inputProps={{ 'aria-label': 'primary checkbox' }}
          />
        )}
        <Typography display="inline" className={classes.label}>
          {label}
        </Typography>
        <Typography display="inline" className={classes.price}>
          {priceBeforeDiscount && (
            <span className={classes.oldPrice}>
              {formattingDigitCurrency(
                priceBeforeDiscount,
                countryCode,
                labelCode,
              )}
            </span>
          )}{' '}
          {offered ? t('offered') : amountFormatting}
        </Typography>
      </div>

      {sublines?.length > 0 && (
        <Grid
          container
          direction="column"
          className={classes.sublines}
          key={sublines}
        >
          {sublines.map((line, i) => (
            <Grid item key={`subline-${i}`}>
              <Typography display="inline" className={classes.sublineTxt}>
                {line.label}
              </Typography>
              <Typography
                display="inline"
                className={`${classes.price} ${classes.sublinePrice}`}
              >
                {line?.priceBeforeDiscount ? (
                  <span className={classes.oldPrice}>
                    {formattingDigitCurrency(
                      line.priceBeforeDiscount,
                      countryCode,
                      labelCode,
                    )}
                  </span>
                ) : (
                  ''
                )}
                {line.price > 0 && name === 'selected' ? '+' : ''}
                {line?.offered ? t('offered') : totalSubline(line.price)}
              </Typography>
            </Grid>
          ))}
        </Grid>
      )}

      <Grid>
        {pricePaid > 0 && pricePaid < price ?
          <Typography display="inline" className={classes.to_pay}>
            {t('rest_to_pay')} : {formattingDigitCurrency(price - pricePaid, countryCode, labelCode)}
          </Typography>
        : null}
      </Grid>
    </>
  );
};

DetailProductLine.propTypes = {
  action: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  idProduct: PropTypes.number,
  idCheckbox: PropTypes.string,
  label: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  quantity: PropTypes.number,
  productSelected: PropTypes.array,
  handleSetItemSelected: PropTypes.func,
};

export default DetailProductLine;
